import {
    Component,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    SimpleChanges,
    ViewEncapsulation,
} from '@angular/core';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { Subject, takeUntil } from 'rxjs';
import { FuseLoadingService } from '@fuse/services/loading';
import { AnimationOptions } from 'ngx-lottie';
import { AnimationItem } from 'lottie-web';
import {
    SUPPORT_THEMES,
    SurveyForceStoreService,
} from '@app/core/services/survey-force-store.service';

@Component({
    selector: 'fuse-loading-bar',
    templateUrl: './loading-bar.component.html',
    styleUrls: ['./loading-bar.component.scss'],
    encapsulation: ViewEncapsulation.None,
    exportAs: 'fuseLoadingBar',
})
export class FuseLoadingBarComponent implements OnChanges, OnInit, OnDestroy {
    @Input() autoMode: boolean = true;
    options: AnimationOptions;
    mode: 'determinate' | 'indeterminate';
    progress: number = 0;
    show: boolean = false;
    theme = '';
    readonly supportThemes = SUPPORT_THEMES;
    private _unsubscribeAll: Subject<any> = new Subject<any>();

    /**
     * Constructor
     */
    constructor(
        private _fuseLoadingService: FuseLoadingService,
        private _sfStoreService: SurveyForceStoreService
    ) {
        this._sfStoreService
            .watchAppTheme()
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((theme) => {
                if (theme) {
                    switch (theme) {
                        case SUPPORT_THEMES.ONEU: {
                            this.theme = SUPPORT_THEMES.ONEU;
                            this.options = {
                                path: '/assets/images/oneu-loading.json',
                            };
                            break;
                        }
                        // case SUPPORT_THEMES.OMRE: {
                        //     this.theme = SUPPORT_THEMES.OMRE;
                        //     this.options = {
                        //         path: '/assets/images/omre_loading.json',
                        //     };
                        //     break;
                        // }
                        default: {
                            this.theme = SUPPORT_THEMES.VIN_ID;
                            break;
                        }
                    }
                }
            });
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On changes
     *
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {
        // Auto mode
        if ('autoMode' in changes) {
            // Set the auto mode in the service
            this._fuseLoadingService.setAutoMode(
                coerceBooleanProperty(changes.autoMode.currentValue)
            );
        }
    }

    /**
     * On init
     */
    ngOnInit(): void {
        // Subscribe to the service
        this._fuseLoadingService.mode$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((value) => {
                this.mode = value;
            });

        this._fuseLoadingService.progress$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((value) => {
                this.progress = value;
            });

        this._fuseLoadingService.show$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((value) => {
                console.log('check show loading', value, this.theme);
                this.show = value;
            });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    animationCreated(animationItem: AnimationItem): void {}
}
